import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPage';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPage'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ListingPageScanWow = loadable(() => import(/* webpackChunkName: "ListingPageScanWow" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageScanwow/ListingPageScanWow'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPage'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPage'));

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

//Custom pages
const CustomLandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/CustomLandingPage/CustomLandingPage'));
const GuidelinesPage = loadable(() => import(/* webpackChunkName: "GuidelinesPage" */ '../containers/GuidelinesPage/GuidelinesPage'));
const CustomAccountPage = loadable(() => import(/* webpackChunkName: "CustomAccountPage" */ '../containers/CustomAccountPage/CustomAccountPage'));
const PreviewPointCloudPagePC = loadable(() => import(/* webpackChunkName: "PreviewPointCloudPagePC" */ '../containers/PreviewPointCloudPage/PreviewPointCloudPageE57'));
const PreviewPointCloudPageGS = loadable(() => import(/* webpackChunkName: "PreviewPointCloudPageGS" */ '../containers/PreviewPointCloudPage/PreviewPointCloudPageGS'));
const PreviewPointCloudPagePLY = loadable(() => import(/* webpackChunkName: "PreviewPointCloudPagePLY" */ '../containers/PreviewPointCloudPage/PreviewPointCloudPagePLY'));
const AboutUsPage = loadable(() => import(/* webpackChunkName: "AboutUsPage" */ '../containers/AboutUsPage/AboutUsPage'));
const BecomeCreatorPage = loadable(() => import(/* webpackChunkName: "BecomeCreatorPage" */ '../containers/BecomeCreatorPage/BecomeCreatorPage'));
const SellScansPage = loadable(() => import(/* webpackChunkName: "SellScansPage" */ '../containers/SellScansPage/SellScansPage'));
const AcceptableUsePolicyPage =  loadable(() => import(/* webpackChunkName: "AcceptableUsePolicyPage" */ '../containers/AcceptableUsePolicyPage/AcceptableUsePolicyPage'));
const CustomInterviewsPage = loadable(() => import(/* webpackChunkName: "CustomInterviewsPage" */ '../containers/CustomInterviewsPage/CustomInterviewsPage'));
const MobileNotSupportedPage = loadable(() => import(/* webpackChunkName: "CustomInterviewsPage" */ '../containers/MobileNotSupportedPage/MobileNotSupportedPage'));
const ComingSoonPage = loadable(() => import(/* webpackChunkName: "ComingSoonPage" */ '../containers/ComingSoonPage/ComingSoonPage'));
const ScanWowSponsorshipPage = loadable(() => import(/* webpackChunkName: "ScanWowSponsorshipPage" */ '../containers/ScanWowSponsorshipPage/ScanWowSponsorshipPage'));
const ScanWowHowItWorksPage = loadable(() => import(/* webpackChunkName: "ScanWowHowItWorksPage" */ '../containers/ScanWowHowItWorksPage/ScanWowHowItWorksPage'));
const KnowledgeHubPage = loadable(() => import(/* webpackChunkName: "KnowledgeHubPage" */ '../containers/KnowledgeHubPage/KnowledgeHubPage'));
const ContactPage = loadable(() => import(/* webpackChunkName: "ContactPage" */ '../containers/ContactPage/ContactPage'));
const MaintenancePage = loadable(() => import(/* webpackChunkName: "MaintenancePage" */ '../containers/MaintenancePage/MaintenancePage'));
const BlogPage = loadable(() => import(/* webpackChunkName: "MaintenancePage" */ '../containers/BlogPage/BlogPage'));
const Blog1Page = loadable(() => import(/* webpackChunkName: "MaintenancePage" */ '../containers/Blog1Page/Blog1Page'));
const Blog2Page = loadable(() => import(/* webpackChunkName: "MaintenancePage" */ '../containers/Blog2Page/Blog2Page'));
const Blog3Page = loadable(() => import(/* webpackChunkName: "MaintenancePage" */ '../containers/Blog3Page/Blog3Page'));
const AddScanPage = loadable(() => import(/* webpackChunkName: "AddScanPage" */ '../containers/AddScanPage/AddScanPage'));


export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig, accessControlConfig) => {
  const SearchPage = layoutConfig.searchPage?.variantType === 'map' 
    ? SearchPageWithMap 
    : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel' 
    ? ListingPageScanWow//ListingPageCarousel 
    : ListingPageCoverPhoto;

  const isPrivateMarketplace = accessControlConfig?.marketplace?.private === true;
  const authForPrivateMarketplace = isPrivateMarketplace ? { auth: true } : {};
  
  return [
    {
      path: '/',
      name: 'LandingPage',
      component: CustomLandingPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/add-a-scan',
      name: 'AddScanPage',
      component: AddScanPage,
    },
    {
      path: '/maintenance',
      name: 'MaintenancePage',
      component: MaintenancePage,
    },
    {
      path: '/blog',
      name: 'BlogPage',
      component: BlogPage,
    },

    {
      path: '/castles-in-the-cloud-part-two-the-digital-legacy-of-dudley-castle-in-3d/',
      name: 'Blog1Page',
      component: Blog1Page,
    },

    {
      path: '/castles-in-the-cloud-part-one-lockdown-lasers-our-animal-assistants/',
      name: 'Blog2Page',
      component: Blog2Page,
    },

    {
      path: '/scanwow-the-marketplace-turning-the-world-into-3d-assets/',
      name: 'Blog3Page',
      component: Blog3Page,
    },
      {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage,
    },
    {
      path: '/knowledge-hub',
      name: 'KnowledgeHubPage',
      component: KnowledgeHubPage,
    },
    {
      path: '/mobile-not-supported',
      name: 'MobileNotSupportedPage',
      component: MobileNotSupportedPage,
    },
    {
      path: '/sponsorship-partnership-opportunities',
      name: 'ScanWowSponsorshipPage',
      component: ScanWowSponsorshipPage,
    },
    {
      path: '/how-it-works',
      name: 'ScanWowHowItWorksPage',
      component: ScanWowHowItWorksPage,
    },
    {
      path: '/acceptable-use-policy',
      name: 'AcceptableUsePolicyPage',
      component: AcceptableUsePolicyPage,
    },
    {
      path: '/interviews',
      name: 'CustomInterviewsPage',
      component: CustomInterviewsPage,
    },
    {
      path: '/preview-point-cloud/pc/:id',
      name: 'PreviewPointCloudPagePC',
      component: PreviewPointCloudPagePC,
    },
    {
      path: '/preview-point-cloud/gs/:id',
      name: 'PreviewPointCloudPageGS',
      component: PreviewPointCloudPageGS,
    },
    {
      path: '/preview-point-cloud/:id',
      name: 'PreviewPointCloudPagePLY',
      component: PreviewPointCloudPagePLY,
    },
    {
      path: '/about-us',
      name: 'AboutUsPage',
      component: AboutUsPage,
    },
    {
      path: '/become-a-creator',
      name: 'BecomeCreatorPage',
      component: BecomeCreatorPage,
    },
    {
      path: '/sell-scans',
      name: 'SellScansPage',
      component: SellScansPage,
    },
    {
      path: '/coming-soon',
      name: 'ComingSoonPage',
      component: ComingSoonPage,
    },
    {
      path: '/guidelines',
      name: 'GuidelinesPage',
      component: GuidelinesPage,
    },
    {
      path: '/account-settings',
      name: 'AccountPage',
      component: CustomAccountPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
      
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    // NOTE: when the private marketplace feature is enabled, the '/s' route is disallowed by the robots.txt resource.
    // If you add new routes that start with '/s*' (e.g. /support), you should add them to the robotsPrivateMarketplace.txt file.
    {
      path: '/s',
      name: 'SearchPage',
      ...authForPrivateMarketplace,
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id/:variant',
      name: 'ProfilePageVariant',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      // loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/no-:missingAccessRight',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage ,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage ,
    },
  ];
};

export default routeConfiguration;
